import { useTranslation } from 'react-i18next';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { INFLUENCER_STATUS_OPTIONS } from '@anytag/shared-constants';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const InfluencerStatusesField = (
  props: Omit<MultipleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const statusesOptions = useTranslateOptions(INFLUENCER_STATUS_OPTIONS);

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="statuses"
      options={statusesOptions}
      title={t('Selector.Influencer Status')}
      multiple
      {...props}
    />
  );
};
